/* eslint-disable no-underscore-dangle */
import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import Root from './index';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  // eslint-disable-next-line no-unused-vars
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  }
});

const loadBrowserCompatibility = () => {
  const script = document.createElement('script');
  script.innerHTML = `
      document.addEventListener('DOMContentLoaded', function() {
        var supportedBrowsers = [
          {
            name: bowser.BROWSER_MAP.ie,
            lastVersion: '>=11'
          },
          {
            name: bowser.BROWSER_MAP.chrome,
            lastVersion: '>=80'
          },
          {
            name: bowser.BROWSER_MAP.firefox,
            lastVersion: '>=68'
          }
        ];

        var currentBrowser = bowser.getParser(window.navigator.userAgent);
        function isSupported() {
          for (var i = 0; i < supportedBrowsers.length; i++) {
            var satisfy = {};
            satisfy[supportedBrowsers[i].name] = supportedBrowsers[i].lastVersion;
            if (supportedBrowsers[i].name === currentBrowser.getBrowserName() && !currentBrowser.satisfies(satisfy)) {
              return false;
            }
          }

          return true;
        }

        var location = window.location;

        if (!isSupported()) {
          location.replace(location.protocol + '//' + location.host + '/old/');
        }
      });
      `;
  document.body.appendChild(script);
};

const loadBowser = () => {
  if (window._bowserLoaded) { return; }// Prevent multiple loads
  window._bowserLoaded = true;

  const script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/bowser@latest/es5.js';
  document.head.appendChild(script);
};

export const {bootstrap} = lifecycles;

export const mount = async props => {
  // Clear Redux state from localStorage
  localStorage.removeItem('redux');
  loadBowser();
  loadBrowserCompatibility();

  return lifecycles.mount(props);
};

export const unmount = async props => {
  // Clear Redux state from localStorage
  localStorage.removeItem('redux');

  return lifecycles.unmount(props);
};
